// Header compartido por las pantallas del kine. Marca + DarkModeToggle +
// nombre del kine + avatar. En mobile incluye un botón hamburger que
// dispara el callback onMenuClick (usado para abrir el KineSidebar
// drawer). En desktop el botón se oculta porque el sidebar está
// siempre visible.
//
// El nombre del kine se oculta en mobile (hidden md:inline) para
// preservar espacio; el avatar queda como identificador.

import { Menu } from "lucide-react";
import { Avatar } from "../Avatar";
import { DarkModeToggle } from "../DarkModeToggle";
import { RoleToggle } from "../RoleToggle";
import logoGonixLight from "@/assets/logo-gonix-light.png";
import logoGonixDark from "@/assets/logo-gonix-dark.png";

interface Props {
  kineNombre: string | undefined;
  /** Disparado al click del botón hamburger en mobile. Las pantallas
   *  manejan el state del drawer localmente (3 líneas de boilerplate
   *  por pantalla, ver bloque I commit 1 para razonamiento). */
  onMenuClick: () => void;
}

export function KineHeader({ kineNombre, onMenuClick }: Props) {
  const displayName = kineNombre ?? "—";
  return (
    <div className="bg-card border-b border-border shadow-sm">
      <div className="max-w-[1400px] mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuClick}
            className="md:hidden p-1 -ml-1 hover:bg-muted rounded transition-colors"
            aria-label="Abrir menú"
          >
            <Menu className="w-6 h-6" strokeWidth={1.5} />
          </button>
          <img
            src={logoGonixLight}
            alt="Gonix"
            className="block dark:hidden h-10 w-auto object-contain"
          />
          <img
            src={logoGonixDark}
            alt="Gonix"
            className="hidden dark:block h-10 w-auto object-contain"
          />
        </div>
        <div className="flex items-center gap-3 md:gap-4">
          <RoleToggle />
          <DarkModeToggle />
          <span className="hidden md:inline text-sm">{displayName}</span>
          <Avatar name={displayName} colorIndex={0} />
        </div>
      </div>
    </div>
  );
}
